import { Form } from '@unform/web';
import React, { useCallback, useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Input from 'src/components/Forms/Input';
import { useLoading } from 'src/hooks/LoadingHook';
import api from 'src/services/api';
import { Container } from './styles';

const InvitationConfirmation: React.FC = () => {
  const { addLoading, removeLoading } = useLoading();
  const { user_hash, invitationHash } = useParams<Record<string, any>>();
  const [ready, setReady] = useState(false);
  const [state, setState] = useState('waiting');
  const [errorMessage, setErrorMessage] = useState('');
  const [name, setName] = useState('');
  const [categoryId, setCategoryId] = useState('');

  const checkInvitation = async (userHash, invitation) => {



    addLoading({ title: 'Validando convite', key: 'loading' });

    try {


      const response = await api.get(`/invitation-check-participation/${userHash}/${invitation}`)

      if (response?.data?.type === 'error') {
        setState('error');
        setErrorMessage(response?.data?.message);
      }

      else {
        setReady(true);
        setName(response?.data?.name)
        setCategoryId(response?.data?.category_id)
      }

      removeLoading('loading');

    }
    catch (err) {
      removeLoading('loading');
      setState('error');
      setErrorMessage('Erro ao confirmar participação')
    }


  }


  useEffect(() => {

    if (invitationHash && user_hash) {
      checkInvitation(user_hash, invitationHash)
    }

  }, [
    user_hash, invitationHash
  ])


  const sendConfirmation = async (userHash, invitation, changed_by = '') => {


    addLoading({ title: 'Confirmando participação', key: 'loading' });

    try {


      const response = await api.post(`/invitation-confirm-participation/${userHash}/${invitation}`, { changed_by: changed_by })

      if (response?.data?.type === 'error') {
        setState('error');
        setErrorMessage(response?.data?.message);
      }

      else {
        setState('success');
      }

      removeLoading('loading');

    }
    catch (err) {
      removeLoading('loading');
      setState('error');
      setErrorMessage(err?.response?.data?.message || 'Erro ao confirmar participação')
    }



  }





  if (state === 'error') {

    return (
      <Container style={{ background: '#fff', margin: '0px' }}>
        <img src='/assets/logo2.png' style={{ width: '300px', margin: '30px auto' }} />
        <h2 style={{ color: '#333', fontSize: '16px' }}>{errorMessage}</h2>



      </Container>
    );

  }

  if (state === 'success') {

    return (
      <Container style={{ background: '#fff', margin: '0px' }}>
        <img src='/assets/logo2.png' style={{ width: '300px', margin: '30px auto' }} />
        <h2 style={{ color: 'rgb(0,100,200)', fontSize: '16px' }}>Participação confirmada com sucesso!</h2>



      </Container>
    );

  }
  if (!ready) {

    return (
      <Container style={{ background: '#fff', margin: '0px' }}>
        <img src='/assets/logo2.png' style={{ width: '300px', margin: '30px auto' }} />
        <h2 style={{ color: '#333', fontSize: '16px' }}>Validando sua confirmação</h2>



      </Container>
    );

  }
  return (
    <Container style={{ background: '#fff', margin: '0px' }}>
      <img src='/assets/logo2.png' style={{ width: '300px', margin: '30px auto' }} />
      <h2 style={{ color: '#333', fontSize: '16px' }}>Olá, {name}.</h2>

      <p style={{ color: '#333', margin: '15px 0px', fontSize: '16px' }}>Clique no botão abaixo para confirmar sua presença</p>

      <button className='greenButton2' onClick={() => sendConfirmation(user_hash, invitationHash)}>Confirmar participação</button>
      {categoryId === 'Patrocinador' ? <>
        <p style={{ color: '#333', margin: '15px 0px', fontSize: '16px', maxWidth: '400px', width: '100%', marginTop: '30px', paddingTop: '30px', borderTop: '2px solid #ddd', textAlign: 'center' }}>Caso queira indicar outro participante para utilizar este convite, informe o nome abaixo e confirme.</p>

        <Form onSubmit={(data) => sendConfirmation(user_hash, invitationHash, data?.name)}>
          <Input name='name' type='text' placeholder='Nome do participante' />
          <button className='greenButton2' style={{ margin: '15px auto' }}  >Confirmar</button>

        </Form>
      </> : <></>}

    </Container>
  );
};
export default InvitationConfirmation;
